import { render, staticRenderFns } from "./CellRendererCurrency.vue?vue&type=template&id=54e0dd22&"
import script from "./CellRendererCurrency.vue?vue&type=script&lang=js&"
export * from "./CellRendererCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports